import React, { useMemo, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Table } from "reactstrap";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import { convertPayment, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraDutyPaymentClaimList, resetAll } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import CustomMonthPicker from "common/CustomMonthPicker";
import { FaCheck } from "react-icons/fa";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const PaymentClaim = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [authDetails, setAuthDetails] = useState(null);
    const dispatch = useDispatch()

    // const { categories } = useSelector((state) => state.CategoryMaster || {});
    // const { departments } = useSelector((state) => state.DepartmentMaster || {});
    // const { designations } = useSelector((state) => state.DesignationMaster || {});

    const {
        extraDutyPaymentClaimList,
        dropdownAutoList,
        categories,
        departments,
        designations,
        loading,
        success,
        error,
        } = useSelector((state) => ({
        categories: state.CategoryMaster?.categories ?? [],
        departments: state.DepartmentMaster?.departments ?? [],
        designations: state.DesignationMaster?.designations ?? [],
        dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
        extraDutyPaymentClaimList: state.AttendanceExtraDutyReducer?.extraDutyPaymentClaimList ?? [],

        loading: state.AttendanceExtraDutyReducer?.loading,
        error: state.AttendanceExtraDutyReducer?.error,
        success: state.AttendanceExtraDutyReducer?.success,
    }));
    const [timesheetApprovalData, setTimesheetApprovalData] = useState();


    useEffect(() => {
        if (extraDutyPaymentClaimList && extraDutyPaymentClaimList.length > 0) {          
            const initializedData = (extraDutyPaymentClaimList || []).map(row => ({
            ...row,
                selectedOption: "Discussion",
            }));
            setTimesheetApprovalData(initializedData)
        }else{
            setTimesheetApprovalData([])
        }
    }, [extraDutyPaymentClaimList])

     useEffect(() => {
        if (success) {
            handleCancel();
        }
    }, [authDetails,success,dispatch]);

    useEffect(() => {
        dispatch(resetAll());
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchDepartments(unitId));
        dispatch(fetchCategories(unitId));
        dispatch(fetchDesignations(unitId));
        dispatch(fetchEmployeeDropdownAutoList(unitId));
    }, [dispatch]);


    // Formik Setup
    const formik = useFormik({
        initialValues: {
            category: [],        
            department: [],      
            designation: [],     
            employee: null,      
            fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),        
        },
        validationSchema: Yup.object({                
            fromDate: Yup.string().nullable()
                .required("Month is required"),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("emp_id", values.employee?.value || "");         
            formData.append("sal_month", values.fromDate || "");                 
            formData.append("dept_id", values.department?.join(",") || "");  
            formData.append("cat_id", values.category?.join(",") || "");     
            formData.append("desig_id", values.designation?.join(",") || "");     
            formData.append("unit_id", authDetails?.unit_id || "");
            formData.append("create_by", authDetails?.user_id || "");
            dispatch(fetchExtraDutyPaymentClaimList(formData))
        },
    });

    const handleBulkActionChange = (action, checked) => {
        const updatedData = (timesheetApprovalData || []).map((row) => ({
            ...row,
            selectedOption: checked ? action : "", // clear if unchecked
        }));
        setTimesheetApprovalData(updatedData);
    };

    const handleOptionChange = (rowId, action, checked) => {
        const updatedData = timesheetApprovalData.map((row) => {
            if (row.emp_id === rowId) {
            return { ...row, selectedOption: checked ? action : "" }; // toggle
            }
            return row;
        });
        setTimesheetApprovalData(updatedData);
    };


    const columns = [
            { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index, className: "serial-no", applyHeaderClass: true, },
            { Header: "Code", accessor: "emp_no" },
            { Header: "Name", accessor: "emp_name" },
            { Header: "Category", accessor: "emp_category" },
            { Header: "Department", accessor: "department" },
            { Header: "Month", accessor: "month_name" },
            { Header: "Available Hrs", accessor: "balance_bank_hour" },
            { Header: "Approved Hrs", accessor: "approved_hours" },
            { Header: "Remarks", accessor: "payment_remarks" },
            {
                id: "approve",
                Header: () => {
                    const allSelected = (timesheetApprovalData || []).every(
                    (row) => row.selectedOption === "Approve"
                    );

                    return (
                    <div className="text-center">
                        <Input
                        type="checkbox"
                        checked={allSelected}
                        onChange={(e) => handleBulkActionChange("Approve", e.target.checked)}
                        />
                    </div>
                    );
                },
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center align-items-center">
                    <Input
                        type="checkbox"
                        checked={row.original.selectedOption === "Approve"}
                        onChange={(e) =>
                        handleOptionChange(row.original.emp_id, "Approve", e.target.checked)
                        }
                    />
                    </div>
                ),
            }
    ];

    const handleLateApprove = () => {
        const updatedApprovals = (timesheetApprovalData || [])
            .filter(item => item.selectedOption === "Approve") // ✅ Only Approve
            .map(item => ({
            extra_hours_paymentid: "0", 
            emp_id: item.emp_id?.toString() || "",
            month: item.salary_month,
            balance_mins: item.balance_mins?.toString() || "0",
            apphrs: item.approved_hours || "00:00",
            remarks: "", 
            }));

        if (updatedApprovals.length === 0) {
            Swal.fire({
            icon: "warning",
            title: "No Selection",
            text: "Please select at least one before proceeding.",
            });
            return;
        }

        // ✅ Final payload structure
        const payload = { payment: updatedApprovals };
        const convertObject = JSON.stringify(payload);

        // ✅ FormData build
        const formData = new FormData();
        formData.append("lst_employee_ConvertPayment", convertObject);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("create_by", authDetails?.user_id);

        // ✅ Dispatch saga action
        dispatch(convertPayment(formData));
    };


    const handleCancel = () => {
        setTimesheetApprovalData([])
        formik.resetForm()
    }


    return (

        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Extra Duty" breadcrumbItem="Payment Claim" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <form onSubmit={formik.handleSubmit}>
                                        <Row >
                                            {/* Category */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Category</Label>
                                                    <CustomSelect
                                                        id="category"
                                                        name="category"
                                                        options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                                                        value={
                                                            categories
                                                                .filter(cat => formik.values.category?.includes(cat.empCatgryid))
                                                                .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                                                        }
                                                        onChange={val => formik.setFieldValue('category', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                                                        classNamePrefix="custom-select"
                                                    />
                                                    {formik.errors.category && formik.touched.category && (
                                                        <div className="text-danger">{formik.errors.category}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* Department */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Department</Label>
                                                    <CustomSelect
                                                        id="department"
                                                        name="department"
                                                        options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                                                        value={
                                                            departments
                                                                .filter(dept => formik.values.department?.includes(dept.departmentId))
                                                                .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                                                        }
                                                        onChange={val => formik.setFieldValue('department', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}

                                                    />
                                                    {formik.errors.department && formik.touched.department && (
                                                        <div className="text-danger">{formik.errors.department}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>


                                            {/* Designation */}
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label>Designation</Label>
                                                    <CustomSelect
                                                        id="designation"
                                                        name="designation"
                                                        options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                                                        value={
                                                            designations
                                                                .filter(desig => formik.values.designation?.includes(desig.desig_id))
                                                                .map(desig => ({ value: desig.desig_id, label: desig.designation }))
                                                        }
                                                        onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                                                        isMulti
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}

                                                    />
                                                    {formik.errors.designation && formik.touched.designation && (
                                                        <div className="text-danger">{formik.errors.designation}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                <Label for="employee">Employee</Label>
                                                <CustomSelect
                                                    id="employee"
                                                    name="employee"
                                                    options={(dropdownAutoList || []).map(emp => ({ value: emp.emp_id.toString(), label: emp.emp_no }))}
                                                    value={formik.values.employee || null}
                                                    onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                                                />
                                                {formik.touched.employee && formik.errors.employee && (
                                                    <div className="text-danger">{formik.errors.employee}</div>
                                                )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3} className="mb-3">
                                                <FormGroup>
                                                <Label for="fromDate">Month <span className="text-danger">*</span></Label>
                                                <CustomMonthPicker
                                                    name="fromDate"
                                                    value={formik.values.fromDate}
                                                    onChange={(date) => formik.setFieldValue("fromDate", date)}
                                                    onBlur={formik.handleBlur}
                                                    disableFuture={true}
                                                    className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                                                />
                                                {formik.touched.fromDate && formik.errors.fromDate && (
                                                    <div className="text-danger">{formik.errors.fromDate}</div>
                                                )}
                                                </FormGroup>
                                            </Col>

                                            {/* Buttons */}
                                            <Col className="d-flex align-items-center justify-content-end mob-center">
                                                <Button type="submit" className="btn button-search me-2">
                                                    <i className="fas fa-search me-1" /> Search
                                                </Button>
                                                <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                                {canCreate && timesheetApprovalData && timesheetApprovalData.length > 0 ? (
                                                    <Button type="button" className="btn button-save" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleLateApprove();
                                                                }}>
                                                        <i className="fas fa-paper-plane me-1" /> Submit
                                                    </Button>
                                                ):''}
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <TableContainer
                                        columns={columns}
                                        data={timesheetApprovalData && timesheetApprovalData.length > 0 ? timesheetApprovalData : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>


    );
};

export default PaymentClaim;
